import { Navigate, Outlet } from "react-router-dom"

/**
 * Poartă pentru rutele care presupun un angajator autentificat.
 *
 * Până acum `MainLayout` nu verifica nimic: `/home`, `/candidates`, `/credits` se
 * deschideau fără token, iar paginile doar eșuau tăcut la primul apel de API.
 *
 * Prezența token-ului nu îi garantează validitatea (nu îi verificăm expirarea aici) —
 * dacă e expirat, primul răspuns 401 curăță sesiunea și aduce userul înapoi la login,
 * vezi `adapters/api.tsx`.
 */
export const ProtectedRoute = () => {
    const token = localStorage.getItem("jwtToken")
    return token ? <Outlet /> : <Navigate to="/" replace />
}
